$(document).ready(function(){  
    $('.content-opener').on('click', function(e) {
        if ($(window).width() < 992) {
            if($(this).hasClass('expanded')){
                $(this).removeClass('expanded');
                $(this).find('.content').slideUp();
            } else {
                $(this).addClass('expanded');
                $(this).find('.content').slideDown();
            }
        }
    });
});